import Login from './Login.vue';

export const routes = [
	{
		name: 'login',
		path: '/login',
		component: Login
	}
];
